/* Sleep Suisse theme scripts. Drawer, chip switchers, product buy box, reviews wiring. */
(function () {
  var $ = function (id) { return document.getElementById(id); };
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- mobile drawer ---- */
  var mnav = $('mnav');
  var burger = document.querySelector('.burger');
  if (mnav && burger) {
    var closeBtn = mnav.querySelector('.mnav__close');
    var setOpen = function (open) {
      mnav.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) { if (closeBtn) closeBtn.focus(); } else { burger.focus({ preventScroll: true }); }
    };
    burger.addEventListener('click', function () { setOpen(!mnav.classList.contains('is-open')); });
    mnav.addEventListener('click', function (e) {
      if (e.target.closest('[data-mnav-close]') || e.target.closest('a')) setOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mnav.classList.contains('is-open')) setOpen(false);
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 1000 && mnav.classList.contains('is-open')) setOpen(false);
    });
  }

  /* ---- "Shop the Pillow" on the product page: glide to the pack picker and pulse it, so the tap
     visibly does something even when the picker is already on screen ---- */
  document.querySelectorAll('a[href="#choose"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = $('choose');
      if (!target) return;
      e.preventDefault();
      setTimeout(function () {
        target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
        target.classList.remove('is-flash'); void target.offsetWidth; target.classList.add('is-flash');
      }, 40);
    });
  });

  /* ---- cart count in the header, kept fresh when a page comes back from the browser's back/forward cache ---- */
  var setCartCount = function (n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      if (el.classList.contains('cartico__n')) el.hidden = n === 0;
    });
  };
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (c) { setCartCount(c.item_count); }).catch(function () {});
  });

  /* ---- generic switchers: [data-switch] holds buttons with data-title / data-body ---- */
  document.querySelectorAll('[data-switch]').forEach(function (root) {
    var btns = root.querySelectorAll('button');
    var t = document.querySelector(root.dataset.switchTitle);
    var b = document.querySelector(root.dataset.switchBody);
    btns.forEach(function (el) {
      el.addEventListener('click', function () {
        btns.forEach(function (o) { o.setAttribute('aria-pressed', String(o === el)); });
        if (t) t.textContent = el.dataset.title;
        if (b) b.textContent = el.dataset.body;
      });
    });
  });

  /* ---- comparison "why it matters" toggle ---- */
  var cmpWhy = $('cmpWhy'), cmpWrap = $('cmpwrap');
  if (cmpWhy && cmpWrap) {
    cmpWhy.addEventListener('click', function () {
      var on = cmpWhy.getAttribute('aria-pressed') === 'true';
      cmpWhy.setAttribute('aria-pressed', String(!on));
      cmpWrap.classList.toggle('show-why', !on);
    });
  }

  /* ---- survey bars ---- */
  var bars = document.querySelectorAll('.bigbar__f');
  var fillBars = function () { bars.forEach(function (b) { b.style.width = b.dataset.pc + '%'; }); };
  if ('IntersectionObserver' in window && bars.length && $('bigbars')) {
    var io = new IntersectionObserver(function (entries, obs) {
      if (entries[0].isIntersecting) { fillBars(); obs.disconnect(); }
    }, { threshold: 0.25 });
    io.observe($('bigbars'));
  } else { fillBars(); }

  /* ---- reviews (preview on product page, full list on reviews page). The review data is a separate
     file, loaded only when the reviews are about to be seen. ---- */
  var list = $('rlist');
  if (list && window.SSReviews) {
    var startReviews = function () { window.SSReviews.load(list.dataset.src, initReviews); };
    var host = list.closest('section') || list;
    if (list.dataset.lazy && 'IntersectionObserver' in window) {
      var rio = new IntersectionObserver(function (entries, obs) {
        if (entries[0].isIntersecting) { obs.disconnect(); startReviews(); }
      }, { rootMargin: '1200px 0px' });
      rio.observe(host);
    } else { startReviews(); }
  }

  function initReviews(all) {
    var R = window.SSReviews;
    var pageSize = Number(list.dataset.limit) || 12;
    var paged = !list.dataset.limit;
    var state = { star: 'all', topic: 'all', sort: 'recent', shown: pageSize };
    var empty = $('rempty'), count = $('rcount'), more = $('rmore');
    var stats = R.stats(all);

    document.querySelectorAll('[data-rv-count]').forEach(function (el) { el.textContent = R.fmt(stats.count); });
    document.querySelectorAll('[data-rv-score]').forEach(function (el) { el.textContent = stats.score; });
    if ($('rbars')) R.bars($('rbars'), stats);
    if ($('cAll')) $('cAll').textContent = R.fmt(stats.count);
    document.querySelectorAll('#rstars [data-star]').forEach(function (b) {
      if (b.dataset.star === 'all') return;
      var c = stats.dist[b.dataset.star] || 0;
      var span = b.querySelector('span'); if (span) span.textContent = R.fmt(c);
      b.hidden = c === 0;
    });

    var paint = function () {
      var rows = all.filter(function (r) {
        return (state.star === 'all' || r.r === Number(state.star)) && (state.topic === 'all' || r.k.indexOf(state.topic) !== -1);
      });
      if (state.sort !== 'recent') {
        var dir = state.sort === 'high' ? -1 : 1;
        rows = rows.map(function (r, i) { return [r, i]; })
          .sort(function (a, b) { return (a[0].r - b[0].r) * dir || a[1] - b[1]; })
          .map(function (x) { return x[0]; });
      }
      var shown = rows.slice(0, state.shown);
      list.innerHTML = shown.map(R.card).join('');
      if (empty) empty.hidden = rows.length > 0;
      if (count) count.textContent = rows.length ? 'Showing ' + R.fmt(shown.length) + ' of ' + R.fmt(rows.length) + (rows.length === 1 ? ' review' : ' reviews') : '';
      if (more) more.hidden = !paged || shown.length >= rows.length;
    };
    var reset = function () { state.shown = pageSize; paint(); };
    R.group($('rstars'), 'star', function (v) { state.star = v; reset(); });
    R.group($('rtopics'), 'topic', function (v) { state.topic = v; reset(); });
    if ($('rsort')) $('rsort').addEventListener('change', function (e) { state.sort = e.target.value; reset(); });
    if (more) more.addEventListener('click', function () { state.shown += pageSize; paint(); });
    paint();
  }

  /* ---- product buy box. A pack of 1 to 3 pillows, each with its own colour. Every pillow is added as a
     single "One pillow" line; the bundle price is applied by automatic discounts set up in Shopify admin.
     There is a discount on EVERY tier including a single pillow (pct1), so the percentages here must match
     all three discounts exactly or the page promises a price the checkout will not honour. ---- */
  var dataEl = $('ss-product-data');
  if (!dataEl) return;
  var data = JSON.parse(dataEl.textContent);
  var variants = data.variants;
  var maxQty = Math.max(1, data.packs.length);
  var qty = Math.min(Math.max(1, data.selected.qty || 1), maxQty);
  var slots = [], touched = [];
  for (var i = 0; i < maxQty; i++) { slots.push(data.selected.colour); touched.push(false); }
  var busy = false;

  /* Add-on (Cooling Cover). Unticked on load; when ticked, one cover per pillow in the pack goes into the
     cart in the colour picked in its menu. Its price is the cover's own price, no discount involved. */
  var addonTick = $('addonTick'), addonSel = $('addonSel');
  var addonVariant = function () {
    if (!data.addon || !data.addon.length) return null;
    var id = addonSel ? Number(addonSel.value) : null;
    return data.addon.filter(function (v) { return id ? v.id === id : v.available; })[0] || null;
  };
  var addonOn = function () { var v = addonVariant(); return !!(addonTick && addonTick.checked && v && v.available); };

  /* Prices are written in whatever currency Shopify is showing this visitor. The sample is 1234567.89
     rendered by the shop's own money format, so the separators and decimals here match the page.
     The thousands grouping is done by hand rather than with a regex: this file is edited through the
     Admin API, where a backslash in a pattern is one escaping mistake away from silently matching
     nothing, and the only symptom would be a dirham price printed without its separator. */
  var money = (function (sample, code) {
    var dec = '.', group = '', decimals = 2, seps = [];
    for (var i = 0; i < sample.length; i++) if (!/[0-9]/.test(sample.charAt(i))) seps.push({ ch: sample.charAt(i), i: i });
    if (seps.length) {
      var last = seps[seps.length - 1];
      if (sample.length - last.i - 1 === 2) { dec = last.ch; } else { decimals = 0; }
      var groupSeps = seps.slice(0, decimals ? seps.length - 1 : seps.length);
      if (groupSeps.length) group = groupSeps[0].ch;
    }
    return function (cents) {
      var parts = (cents / 100).toFixed(decimals).split('.');
      var whole = parts[0];
      if (group && whole.length > 3) {
        var out = '', n = whole.length;
        for (var j = 0; j < n; j++) {
          if (j > 0 && (n - j) % 3 === 0) out += group;
          out += whole.charAt(j);
        }
        whole = out;
      }
      return code + ' ' + whole + (decimals ? dec + parts[1] : '');
    };
  })(data.money_sample || '1234567.89', data.currency);
  var chf = money;
  var setText = function (id, txt) { var el = $(id); if (el) el.textContent = txt; };
  var setImg = function (id, src) { var el = $(id); if (el && src) el.src = src; };
  var single = function (colour) {
    return variants.filter(function (v) { return v.colour === colour && v.pack === data.one; })[0];
  };
  var packVariant = function (colour, q) {
    return variants.filter(function (v) { return v.colour === colour && v.pack === data.packs[q - 1]; })[0];
  };
  var pctFor = function (q) { return q >= 3 ? data.pct3 : q === 2 ? data.pct2 : (data.pct1 || 0); };
  var joinWords = function (arr) {
    return arr.length < 2 ? arr.join('') : arr.slice(0, -1).join(', ') + ' and ' + arr[arr.length - 1];
  };

  /* Price of the current choice. Pillows of the same colour become one cart line, and Shopify takes the
     bundle percentage off the line, so the rounding here is done per colour to match the cart to the cent. */
  function quote(colours) {
    var pct = pctFor(colours.length), total = 0, was = 0, ok = true, counts = {};
    colours.forEach(function (c) { counts[c] = (counts[c] || 0) + 1; });
    Object.keys(counts).forEach(function (c) {
      var v = single(c), n = counts[c];
      if (!v || !v.available) { ok = false; return; }
      var gross = v.price * n;
      total += gross - Math.round((gross * pct) / 100);
      was += Math.max(v.compare_at || 0, v.price) * n;
    });
    return { total: total, was: was, ok: ok };
  }

  function render() {
    var chosen = slots.slice(0, qty);
    var quoteNow = quote(chosen);

    /* pack cards: priced on pillow 1's colour. Largest type is the total they pay, with the
       undiscounted total struck through beside it; underneath, the reason to take this pack
       and the percentage saved. Must stay identical to the Liquid in sections/ss-product-buy. */
    document.querySelectorAll('.pack').forEach(function (p) {
      var q = Number(p.dataset.qty);
      p.setAttribute('aria-pressed', String(q === qty));
      var c = [];
      for (var k = 0; k < q; k++) c.push(slots[0]);
      var pq = quote(c);
      p.classList.toggle('is-unavailable', !pq.ok);
      var priceEl = p.querySelector('.pack__price'), subEl = p.querySelector('.pack__sub');
      if (priceEl) priceEl.innerHTML = (pq.was > pq.total ? '<s>' + chf(pq.was) + '</s>' : '') + chf(pq.total);
      if (subEl) {
        var why = (data.subs && data.subs[q - 1]) || '';
        var pc = pctFor(q);
        subEl.innerHTML = '<span class="pack__why">' + why + '</span>' +
          (pc > 0 ? '<span class="pack__save">Save ' + Math.round(pc) + '%</span>' : '');
      }
    });

    /* colour rows: one row per pillow in the pack */
    var wrap = $('pillows');
    if (wrap) {
      wrap.classList.toggle('is-multi', qty > 1);
      wrap.querySelectorAll('.pillow').forEach(function (row) {
        var k = Number(row.dataset.slot) - 1;
        row.hidden = k >= qty;
        var name = row.querySelector('[data-slot-name]'); if (name) name.textContent = slots[k];
        row.querySelectorAll('.swatch').forEach(function (s) { s.setAttribute('aria-pressed', String(s.dataset.colour === slots[k])); });
      });
    }
    document.querySelectorAll('[data-head-one]').forEach(function (el) { el.hidden = qty > 1; });
    document.querySelectorAll('[data-head-many]').forEach(function (el) { el.hidden = qty === 1; });
    var mix = $('mixNote'); if (mix) mix.hidden = qty === 1;
    setText('colourName', slots[0]);

    /* buttons and sticky bar */
    var packWord = (data.packs[qty - 1] || '').toLowerCase();
    var unique = chosen.filter(function (c, idx) { return chosen.indexOf(c) === idx; });
    setText('barMeta', joinWords(unique) + (packWord ? ', ' + packWord : ''));
    var first = single(slots[0]);
    if (first) setImg('barImg', first.image);
    /* add-on card: price for one cover per pillow, "x2" beside the name once the pack is bigger than one */
    var av = addonVariant(), addonTotal = 0;
    if (av) {
      /* the Buy X get Y discount takes addon_pct off each cover bought with a pillow, rounded on the line like Shopify */
      var aGross = av.price * qty, aWas = Math.max(av.compare_at || 0, av.price) * qty;
      var aNow = aGross - Math.round((aGross * (data.addon_pct || 0)) / 100);
      var ap = $('addonPrice');
      if (ap) ap.innerHTML = (aWas > aNow ? '<s>' + chf(aWas) + '</s>' : '') + chf(aNow);
      var aq = $('addonQty');
      if (aq) { aq.hidden = qty === 1; aq.textContent = 'x' + qty; }
      if (av.image) setImg('addonImg', av.image);
      if (addonOn()) addonTotal = aNow;
    }
    if (!busy) {
      document.querySelectorAll('[data-add]').forEach(function (b) {
        b.textContent = (b.dataset.label || 'Add to cart') + (quoteNow.ok ? ', ' + chf(quoteNow.total + addonTotal) : ', sold out');
        b.disabled = !quoteNow.ok;
      });
    }
    var pv = packVariant(slots[0], qty);
    if (pv && history.replaceState) {
      var url = new URL(window.location.href); url.searchParams.set('variant', pv.id);
      history.replaceState(history.state, '', url.toString());
    }
  }

  document.querySelectorAll('.pack').forEach(function (p) {
    p.addEventListener('click', function () {
      qty = Math.min(Number(p.dataset.qty) || 1, maxQty);
      /* pillows the shopper has not picked yet follow pillow 1 */
      for (var k = 1; k < maxQty; k++) if (!touched[k]) slots[k] = slots[0];
      render();
    });
  });

  document.querySelectorAll('.pillow').forEach(function (row) {
    var k = Number(row.dataset.slot) - 1;
    row.querySelectorAll('.swatch').forEach(function (s) {
      s.addEventListener('click', function () {
        if (s.disabled) return;
        slots[k] = s.dataset.colour;
        touched[k] = true;
        if (k === 0) { for (var j = 1; j < maxQty; j++) if (!touched[j]) slots[j] = slots[0]; }
        var v = single(slots[k]);
        setImg('mainShot', (v && v.image) || ((s.querySelector('img') || {}).src));
        document.querySelectorAll('.thumb').forEach(function (t) { t.setAttribute('aria-pressed', 'false'); });
        render();
      });
    });
  });

  if (addonTick) addonTick.addEventListener('change', render);
  if (addonSel) addonSel.addEventListener('change', function () { if (addonTick) addonTick.checked = true; render(); });

  document.querySelectorAll('.thumb').forEach(function (el, idx, all) {
    el.addEventListener('click', function () {
      all.forEach(function (o) { o.setAttribute('aria-pressed', String(o === el)); });
      setImg('mainShot', el.dataset.full || el.querySelector('img').src);
    });
  });

  document.querySelectorAll('[data-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (busy) return;
      var counts = {}, order = [];
      for (var k = 0; k < qty; k++) {
        var v = single(slots[k]);
        if (!v || !v.available) return;
        if (!counts[v.id]) { counts[v.id] = 0; order.push(v.id); }
        counts[v.id] += 1;
      }
      var items = order.map(function (id) { return { id: id, quantity: counts[id] }; });
      if (addonOn()) items.push({ id: addonVariant().id, quantity: qty });
      busy = true;
      document.querySelectorAll('[data-add]').forEach(function (b) { b.disabled = true; b.textContent = 'Adding…'; });
      var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, body: j }; });
      }).then(function (res) {
        if (!res.ok || (res.body && res.body.status)) throw new Error((res.body && (res.body.description || res.body.message)) || 'Could not add to cart.');
        window.location.href = data.cart_url;
      }).catch(function (e) {
        busy = false; render();
        alert(e.message || 'Could not add to cart.');
      });
    });
  });

  /* Back button after adding: Safari and Chrome restore this page exactly as it was left, button still
     reading "Adding…". Reset it. */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { busy = false; render(); }
  });

  render();
})();

/* ---- autoplay videos on computers. Phones show a still image and never download a video on their own.
   A computer is a wide window OR a mouse/trackpad, so a narrow browser window on a Mac still gets video.
   The source is attached when the video scrolls into view. Browsers can still refuse muted autoplay
   (Safari in Low Power Mode, or a site set to "Never Auto-Play"); the first click or key press retries.
   On phones, videos inside [data-vidbox] play when tapped (a tap is always allowed to start playback,
   Low Power Mode included). Tap again to pause; scrolling away pauses too. ---- */
(function () {
  var vids = [].slice.call(document.querySelectorAll('video[data-src]'));
  if (!vids.length) return;
  var mq = window.matchMedia('(min-width: 1000px), (hover: hover) and (pointer: fine)');
  if (!mq.matches) {
    vids.forEach(function (v) { v.removeAttribute('autoplay'); });
    mq.addEventListener && mq.addEventListener('change', function (e) { if (e.matches) location.reload(); });
    var boxes = [].slice.call(document.querySelectorAll('[data-vidbox]'));
    boxes.forEach(function (box) {
      var v = box.querySelector('video[data-src]');
      if (!v) return;
      box.addEventListener('click', function () {
        if (!v.paused) { v.pause(); return; }
        box.classList.add('is-loading');
        v.muted = true; v.playsInline = true;
        if (!v.getAttribute('src')) { v.src = v.dataset.src; v.load(); }
        var p = v.play();
        if (p && p.catch) p.catch(function () { box.classList.remove('is-loading'); });
      });
      v.addEventListener('playing', function () {
        box.classList.remove('is-loading');
        box.classList.add('is-started', 'is-playing');
      });
      v.addEventListener('pause', function () { box.classList.remove('is-playing', 'is-loading'); });
    });
    if (boxes.length && 'IntersectionObserver' in window) {
      var pio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target.querySelector('video');
          if (!e.isIntersecting && v && !v.paused) v.pause();
        });
      }, { threshold: 0.1 });
      boxes.forEach(function (b) { pio.observe(b); });
    }
    return;
  }
  function tryPlay(v) {
    v.muted = true; v.defaultMuted = true;
    if (!v.getAttribute('src')) { v.src = v.dataset.src; v.load(); }
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  }
  vids.forEach(function (v) { v.addEventListener('click', function () { if (v.paused) tryPlay(v); }); });
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        e.target.dataset.inview = e.isIntersecting ? '1' : '0';
        if (e.isIntersecting) tryPlay(e.target); else if (e.target.getAttribute('src')) e.target.pause();
      });
    }, { threshold: 0.15, rootMargin: '200px 0px' });
    vids.forEach(function (v) { io.observe(v); });
  } else { vids.forEach(tryPlay); }
  var retry = function () { vids.forEach(function (v) { if (v.paused && v.dataset.inview !== '0') tryPlay(v); }); };
  ['click', 'keydown', 'touchend'].forEach(function (t) { document.addEventListener(t, retry, { capture: true, passive: true }); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) retry(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) retry(); });
})();

/* ---- promo bar: click copies the code and applies it to the checkout session ---- */
(function () {
  document.querySelectorAll('[data-promo-code]').forEach(function (bar) {
    var code = bar.dataset.promoCode, label = bar.querySelector('[data-promo-label]');
    var done = bar.dataset.promoDone || 'Copied';
    bar.addEventListener('click', function () {
      var finish = function () {
        bar.classList.add('is-copied');
        if (label) label.textContent = done;
        setTimeout(function () { bar.classList.remove('is-copied'); if (label) label.textContent = bar.dataset.promoLabel; }, 2600);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(finish, finish);
      else { var t = document.createElement('textarea'); t.value = code; document.body.appendChild(t); t.select(); try { document.execCommand('copy'); } catch (e) {} document.body.removeChild(t); finish(); }
      try { fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin', redirect: 'follow' }).catch(function () {}); } catch (e) {}
    });
  });
})();

/* ---- cart page: quantity stepper submits the cart form on its own ---- */
(function () {
  var form = document.getElementById('ss-cart');
  if (!form) return;
  var submit = function () { form.classList.add('is-busy'); form.submit(); };
  form.querySelectorAll('[data-step]').forEach(function (b) {
    b.addEventListener('click', function () {
      var input = b.parentNode.querySelector('input');
      var n = Math.max(0, (parseInt(input.value, 10) || 0) + Number(b.dataset.step));
      input.value = n; submit();
    });
  });
  form.querySelectorAll('input[name="updates[]"]').forEach(function (i) { i.addEventListener('change', submit); });
  /* back to a cart that was mid update: undo the dimmed state */
  window.addEventListener('pageshow', function (e) { if (e.persisted) form.classList.remove('is-busy'); });
})();
